import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import {
  TextInput,
} from "components/Input/Index.js";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { marketotherfiles } from "variables/markets";
import { putMarketFile, getFiles } from "services/ConfigServices";
import { MarketsContext } from "context/MarketsContext";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Chip from "@mui/material/Chip";
import AdvancedSearchContext from "context/AdvancedSearchContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "65ch",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;

function EditContractDialog(props) {
  const { closeModal, refetch, marketfile } = props;
  const appContext = useContext(MarketsContext);
  const { market } = appContext;

  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = advancedSearchContext;

  const [doctype, setDoctype] = useState(marketfile.parameters.doctype);
  const [docnumber, setDocnumber] = useState(marketfile.parameters.docnumber);
  const [docname, setDocname] = useState(marketfile.parameters.docname);
  const [legalentity, setLegalentity] = useState(marketfile.parameters.legalentity);
  const [representedby, setRepresentedby] = useState(marketfile.parameters.representedby);
  const [datebegin, setDatebegin] = useState(marketfile.parameters.datebegin);
  const [dateend, setDateend] = useState(marketfile.parameters.dateend);
  const [datesignature, setDatesignature] = useState(marketfile.parameters.datesignature);
  const [associatedfiles, setAssociatedfiles] = useState(marketfile.parameters.associatedfiles);

  const handleDoctypeChange = (event) => { setDoctype(event.target.value); };
  const handleDocnumberChange = (event) => { setDocnumber(event.target.value); };
  const handleDocnameChange = (event) => { setDocname(event.target.value); };
  const handleLegalentityChange = (event) => { setLegalentity(event.target.value); };
  const handleRepresentedbyChange = (event) => { setRepresentedby(event.target.value); };
  const handleDatebeginChange = (event) => { setDatebegin(event.target.value); };
  const handleDateendChange = (event) => { setDateend(event.target.value); };
  const handleDatesignatureChange = (event) => { setDatesignature(event.target.value); };

  const [buttonDisabled, setButtonDisabled] = useState(true);

  useEffect(() => {
    if (
      doctype.length > 0 &&
      docname.length > 0
    ) {
      setButtonDisabled(false);
    } else {
      setButtonDisabled(true);
    }
  }, [doctype, docname]);



  const handleSubmit = async (event) => {
    updateMarketFile(event);
  };

  const [gedList, setGedList] = useState([
    { fileName: String, fileId: Number },
  ]);
  useEffect(() => {
    axios
      .get(getFiles(chartIdGroup), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        setGedList(res.data.collection);
      });
  }, []);

  const selectedDocuments = () => {
    let selected = {};
    if (associatedfiles !== undefined) {
      selected = associatedfiles;
    }
    return selected;
  };
  const handleAssociatedfilesChange = (newValue) => {
    setAssociatedfiles(newValue);
  };

  const updateMarketFile = async (event) => {
    await axios
      .put(
        putMarketFile(marketfile.id),
        {
          ...marketfile.parameters,
          doctype,
          docnumber,
          docname,
          legalentity,
          representedby,
          datebegin,
          dateend,
          datesignature,
          associatedfiles,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Pièce de marché modifiée");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        console.log(error);
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const classes = useStyles();

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                isRequired
                inputTitle={marketotherfiles.doctype}
                textInput={doctype}
                handleTextInputChange={handleDoctypeChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={marketotherfiles.docname}
                textInput={docname}
                handleTextInputChange={handleDocnameChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={marketotherfiles.docnumber}
                textInput={docnumber}
                handleTextInputChange={handleDocnumberChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={marketotherfiles.legalentity}
                textInput={legalentity}
                handleTextInputChange={handleLegalentityChange}
              />
            </div>
            <div>
              <TextInput
                inputTitle={marketotherfiles.representedby}
                textInput={representedby}
                handleTextInputChange={handleRepresentedbyChange}
              />
            </div>
            <div>
              <DateInput
                isRequired
                inputTitle={marketotherfiles.datebegin}
                dateInput={datebegin}
                handleDateInputChange={handleDatebeginChange}
              />
            </div>
            <div>
              <DateInput
                isRequired
                inputTitle={marketotherfiles.dateend}
                dateInput={dateend}
                handleDateInputChange={handleDateendChange}
              />
            </div>
            <div>
              <DateInput
                inputTitle={marketotherfiles.datesignature}
                dateInput={datesignature}
                handleDateInputChange={handleDatesignatureChange}
              />
            </div>
            <div>
              <AutocompleteInput
                isMultiple={false}
                specialWidth={"97%"}
                inputTitle={marketotherfiles.associatedfiles}
                selected={selectedDocuments()}
                list={gedList}
                handleChange={(_, newValue) =>
                  handleAssociatedfilesChange(newValue)
                }
                renderTags={(tagValue, getTagProps) =>
                  tagValue.map((option, index) => (
                    <Chip label={option.title} {...getTagProps({ index })} />
                  ))
                }
              />
            </div>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Modifier
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditContractDialog;
